import { animate, query, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { DetailsUser } from 'app/shared/models/Users/detailsUsers';
import { User } from 'app/shared/models/Users/user';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FfvapiService } from 'app/shared/services/ffvApi/ffvapi.service';
import { ProgressionService } from 'app/shared/services/progression/progression.service';
import { TitleService } from 'app/shared/services/title/title.service';
import { UserService } from 'app/shared/services/user/user.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { UnsubscriptionComponent } from './unsubscription/unsubscription.component';

const reader = new FileReader();

@Component({
  selector: 'app-profil',
  templateUrl: './profil.component.html',
  styleUrls: ['./profil.component.scss'],
  animations: [
    trigger('menu', [
      transition(':enter', [
        query('.wrap', [
          style({ opacity: 0, transform: 'translate(-200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ])
      ]),


    ]),
    trigger('update', [
      transition(':enter', [
        query('.wrap', [
          style({ opacity: 0, transform: 'translate(200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ])
      ]),


    ]),

  ]
})

export class ProfilComponent extends SubscriptionBaseComponent implements OnInit {

  menu: any;
  info: string;
  kind: string;
  point = [];
  meilleure: any;

  show: boolean;
  update: boolean;
  myClub: boolean;
  wallOfTrophy: boolean;
  showMyLicence: boolean;



  userLogin: User;
  userFirstName: string;
  userLastName: string;
  userStatut: string;
  userClub: string;
  userSenorioty: string;
  userPhoto: any;


  unlink: boolean;
  userDetails: DetailsUser;
  userFirstNameLink: string;
  userLastNameLink: string;
  userClubLink: string;
  userSenoriotyLink: number;
  userisLink: boolean;
  confirmEmailLicence: boolean;

  isChecked: boolean;

  color: ThemePalette = 'primary';
  showMySkills: boolean;

  constructor(
    private titleService: TitleService,
    private authentificationService: AuthenticationService,
    private userService: UserService,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private ffvService: FfvapiService,
    private jwtHelperSrv: JwtHelperService,
    private progressionService: ProgressionService
  ) {
    super();
    // this.checkIfALicence();
  }

  ngOnInit(): void {
    // if (this.authentificationService.getDecodedToken().licence) {
    //   this.dataService.userIsLink.next(true);
    // }
    this.checkIfALicence();
    this.stayConnected();
    this.dataService.userLogin.next(this.authentificationService.getDecodedToken());
    this.initSub();
    // this.userLogin = this.authentificationService.getDecodedToken();
    this.dataService.showMyClub.next(false);
    this.dataService.showTrophy.next(false);
    this.dataService.showMyLicence.next(false);
    this.dataService.showMySkills.next(false);
    // this.getInfos();
    this.initSub();
    this.getPhotoUser();

    localStorage.setItem('url', this.router.url);

    this.dataService.showupdateProfil.next(false);
    this.dataService.showMenuProfil.next(true);
    this.titleService.title.next('Mon profil');

  }

  openDialog(): void {
    const dialogRef = this.dialog.open(UnsubscriptionComponent);
    dialogRef.afterClosed().subscribe(() => { });
  }

  logout(): void {
    this.authentificationService.logout();
  }

  goToUpdate(): void {
    this.dataService.showupdateProfil.next(true);
  }

  sendFile(event): void {
    const file = event.target.files[0];
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.userService.updateUserPhoto(reader.result).subscribe(res => {
        this.getPhotoUser();
      });
    };
  }

  getStatusConnect(): void {
    const token = this.jwtHelperSrv.tokenGetter();
    const clientID = this.authentificationService.getDecodedToken().client_id;
    if (this.isChecked) {
      this.authentificationService.stayConnected(token, 'web').subscribe(() => { });
    } else {
      this.authentificationService.stayConnected(token, 'long').subscribe(() => { });
    }
  }

  private stayConnected(): void {
    const userInfos = this.authentificationService.getDecodedToken();
    switch (userInfos.client_id) {
      case 'long':
        this.isChecked = true;
        break;
      case 'web':
        this.isChecked = false;
        break;
      default:
        break;
    }
  }

  private checkIfALicence(): void {
    this.ffvService.checkIfALicence().subscribe(res => {
      this.dataService.userIsLink.next(true);
      this.getInfos();
    }, error => {
    });
  }

  private getUserDetails(): void {

    this.ffvService.getDetailsUser().subscribe(res => {
      this.userDetails = res;
      res?.prenom.toLocaleLowerCase()[0].toUpperCase();

      const userLogin = this.authentificationService.getDecodedToken();
      userLogin.given_name = res?.prenom;
      userLogin.family_name = res?.nom;


      this.dataService.userLogin.next(userLogin);

      this.userFirstNameLink = this.userDetails?.prenom;
      this.userLastNameLink = this.userDetails?.nom;
      this.userClubLink = this.userDetails?.club;
      this.userSenoriotyLink = this.userDetails?.nB_SAISONS;

    });
  }

  private getInfos() {
    this.getUserDetails();
    this.userFirstName = this.userLogin.given_name;
    this.userLastName = this.userLogin.family_name;
    this.userClub = this.userLogin.club;
    this.userSenorioty = this.userLogin.startDate;

  }


  private getPhotoUser(): void {
    this.userService.getphoto()
      .subscribe(
        response => {
          const objectURL = 'data:image/jpeg;base64,' + response;

          // this.userPhoto = 'data:image/jpeg;base64,' + response;
          this.userPhoto = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        }
      );
  }
  private initSub(): void {
    this.subscription
      .add(
        this.dataService.showMenuProfil.asObservable().subscribe(show => {
          this.show = show;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.showupdateProfil.asObservable().subscribe(up => {
          this.update = up;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.showMyClub.asObservable().subscribe(show => {
          this.myClub = show;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.showTrophy.asObservable().subscribe(trophy => {
          this.wallOfTrophy = trophy;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.showMyLicence.asObservable().subscribe(showMyLience => {
          this.showMyLicence = showMyLience;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.showMySkills.asObservable().subscribe(skills => {
          this.showMySkills = skills;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.personaUser.asObservable().subscribe(persona => {
          this.userStatut = persona;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.unlink.asObservable().subscribe(unlink => {
          this.unlink = unlink;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.userIsLink.asObservable().subscribe(userIsLink => {
          this.userisLink = userIsLink;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.confirmEmailLicence.asObservable().subscribe(confirm => {
          this.confirmEmailLicence = confirm;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.userLogin.asObservable().subscribe(user => {
          this.userLogin = user;
          this.userFirstName = this.userLogin.given_name;
          this.userLastName = this.userLogin.family_name;
          this.cdr.detectChanges();
        })
      );
  }

}


